import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const ChainLinkIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper {...props} viewBox="0 0 16 16">
      <path
        d="M9.33331 7.9984C9.33331 6.33727 7.78865 4.66667 5.90474 4.66667C5.68159 4.66667 4.94601 4.66668 4.76189 4.66668C2.86834 4.66668 1.33331 6.15835 1.33331 7.9984C1.33331 9.584 2.47313 10.9109 3.99998 11.2476C4.24502 11.3017 4.50002 11.3301 4.76189 11.3301"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66669 7.99841C6.66669 9.65954 8.21135 11.3301 10.0953 11.3301C10.3184 11.3301 11.054 11.3301 11.2381 11.3301C13.1317 11.3301 14.6667 9.83848 14.6667 7.99841C14.6667 6.41281 13.5269 5.08591 12 4.74923C11.755 4.6952 11.5 4.66667 11.2381 4.66667"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
